<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :theme="theme"
        :buttons="buttons"
        :value="homeownerStatus"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="$_loans_updateLead(updateLeadPayload, $_buttonList_dataLayerObject)"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  // Name
  name: 'HomeownerStatus',

  // Components
  components: {
    AppButton,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    buttonList,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'Are You a Homeowner?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'setHomeownerStatus',
      buttonListFieldName: 'homeownerStatus',
      buttons: [{
        text: 'Yes',
        value: 'Yes',
        dataLayer: 'Yes'
      }, {
        text: 'No',
        value: 'No',
        dataLayer: 'No'
      }],
      buttonListDataLayerStepName: 'spring_ploan_homeowner'
    }
  },

  // Computed
  computed: {
    homeownerStatus () {
      return this.$store.state.customer.homeowner_status
    },
    updateLeadPayload () {
      return { homeowner_status: this.homeownerStatus }
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) {
        try {
          await this.$_loans_updateLead(this.updateLeadPayload, this.$_buttonList_dataLayerObject)
        } catch (error) {
          console.error('Failed to update lead:', error)
        } finally {
          this.$store.dispatch('setTriggerContinue', false)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
